<div class="checkout-date-picker">
  <div class="content">
    <form [formGroup]="formGroup">
      <pdq-card variant="popover" color="white">
        <div class="flex-row padding-16">
          <pdq-heading element="h5">Test mode</pdq-heading>
          <pdq-slide-toggle formControlName="testMode" [defaultValue]="!!formGroup.value.testMode"></pdq-slide-toggle>
        </div>
        <pdq-divider></pdq-divider>
        <p class="padding-16">
          Enable test mode to review your date picker on your live shop while hiding it from your end customers.
        </p>
      </pdq-card>

      <pdq-card variant="popover" color="white">
        <div class="flex-row padding-16"><pdq-heading element="h5">Settings</pdq-heading></div>
        <pdq-divider></pdq-divider>
        <div class="flex-col padding-16">
          <pdq-input
            label="Internal name"
            placeholder="ice cream shipments"
            formControlName="internalName"
            [invalid]="formGroup.controls.internalName.errors?.required"
            [invalidMsg]="
              formGroup.controls.internalName.errors?.required ? 'Internal name is required' : ''
            "></pdq-input>
          <p>This will not be shown to customers, it is simply used for organizing your schedules</p>
        </div></pdq-card
      >

      <pdq-card variant="popover" color="white">
        <div class="flex-row padding-16"><pdq-heading element="h5">Configure</pdq-heading></div>
        <pdq-divider></pdq-divider>
        <div class="flex-col padding-16">
          <pdq-radio-group formControlName="placementMode" label="Calendar placement" labelSize="small">
            @for (placementMode of placementModeConfig; track placementMode) {
              <pdq-radio-button
                [value]="placementMode.value"
                [checked]="placementMode.checked(formGroup.value['placementMode']) || placementMode.defaultChecked"
                [text]="placementMode.text">
              </pdq-radio-button>
            }
          </pdq-radio-group>

          <date-picker-types [formGroup]="formGroup"></date-picker-types>

          <pdq-input
            label="Title"
            formControlName="title"
            placeholder="Schedule delivery in Toronto"
            [invalid]="formGroup.controls.title.errors?.required"
            [invalidMsg]="formGroup.controls.title.errors?.required ? 'Title is required' : ''"></pdq-input>
          <pdq-textarea
            [control]="formGroup.controls?.description"
            label="Description (optional)"
            placeholder="You'll choose a date and time at checkout"></pdq-textarea>
          @if (formGroup.controls?.type?.value === 'dateField') {
            <pdq-input label="Label (optional)" placeholder="Label goes here" formControlName="label"></pdq-input>
          }

          <date-picker-geo-rules [formGroup]="formGroup" [shop]="shop$ | async"></date-picker-geo-rules>
          @if (allowExternalVendors) {
            <div class="external-vendors">
              <p class="paragraph-header">Shopify Collective Integrations</p>
              <p>Integrate with an external Vendor</p>

              @for (vendor of externalVendors; track vendor.type) {
                <div class="vendor-item">
                  <pdq-checkbox
                    class="vendor-header"
                    [label]="vendor.label"
                    [checked]="vendor.checked"
                    (onChange)="onVendorCheckedChange(vendor, $event)">
                  </pdq-checkbox>

                  @if (vendor.checked) {
                    <div class="vendor-config">
                      @for (field of getConfigKeys(vendor.type); track field) {
                        @if (field === 'skuPrefix') {
                          <p>Enter SKUs separated by comma (,)</p>
                        }
                        <pdq-input
                          class="vendor-header"
                          [label]="formatConfigLabel(field)"
                          [value]="vendor.config[field]"
                          [debounceTime]="500"
                          (onKeyup)="onVendorConfigChange(vendor, field, $event)">
                        </pdq-input>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      </pdq-card>

      <pdq-card variant="popover" color="white">
        <div class="flex-row padding-16"><pdq-heading element="h5">Active shipping days & times</pdq-heading></div>
        <pdq-divider></pdq-divider>
        <div class="flex-col padding-16">
          <date-picker-shipping-days-n-times
            [formGroup]="formGroup"
            [loadedValues]="loadedExtension?.template?.activeShippingDays"></date-picker-shipping-days-n-times>
        </div>
      </pdq-card>

      <pdq-card variant="popover" color="white">
        <div class="flex-row padding-16"><pdq-heading element="h5"> Availability dates</pdq-heading></div>
        <pdq-divider></pdq-divider>
        <div class="flex-col padding-16">
          <p>Specify the times a customer can select shipping</p>
          <date-picker-availability-dates [formGroup]="formGroup"></date-picker-availability-dates>
        </div>
      </pdq-card>

      <pdq-card variant="popover" color="white">
        <div class="flex-row padding-16"><pdq-heading element="h5">Blackout rules</pdq-heading></div>
        <pdq-divider></pdq-divider>
        <div class="flex-col padding-16">
          <span>Set days as inactive for delivery</span>
          <date-picker-blackout-dates [formGroup]="formGroup" [shop]="shop$ | async"></date-picker-blackout-dates>
        </div>
      </pdq-card>

      <pdq-card variant="popover" color="white">
        <div class="flex-row padding-16"><pdq-heading element="h5">Display conditions</pdq-heading></div>

        <pdq-divider></pdq-divider>
        <div class="flex-col padding-16">
          <p>This Date Picker Will Only Appear If:</p>
          <date-picker-restrictions
            [formGroup]="formGroup"
            [shopCurrencySymbol]="shopCurrencySymbol"></date-picker-restrictions>
        </div>
      </pdq-card>
    </form>
  </div>
</div>
